export default "__VITE_ASSET__BUUs7zBq__"